import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class FMYSalaryGroup  {
    _originalTypeClassName = "zERP.BO.FMYSalaryGroup";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
FMYSalaryGroup.translate = translateService;
}
this.SalaryDetails = [];
this.Key = null;
this.SalaryAmount = null;
this.ContributionsAndDeductionsBeforeTax = null;
this.TaxableAmount = null;
this.TaxAmount = null;
this.SalaryRuleType = null;
this.AadeCode = null;
this._key = this.Key = ""; 
}

static translate: TranslateService;
_key: any;
private _Key:any;
get Key(): any {
    return this._Key;
  }
set Key(value: any) {
    this._Key = value;
    this._key = value;
  }
SalaryAmount:any;
ContributionsAndDeductionsBeforeTax:any;
TaxableAmount:any;
TaxAmount:any;
SalaryRuleType:any;
AadeCode:any;
SalaryDetails:any;
static setSalaryDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.SalaryDetails == null) $this.SalaryDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SalaryDetails.length > 0) {
                    Domain.FMYSalaryGroup.removeSalaryDetails($this, $this.SalaryDetails[0]);
                }

                Domain.FMYSalaryGroup.addManySalaryDetails($this, copyItems);
            }
static addManySalaryDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.FMYSalaryGroup.addSalaryDetails($this, items[i]);
                }
            }
static addSalaryDetails = ($this, item) => {
                if ($this.SalaryDetails == null) $this.SalaryDetails = [];
                if (item == null || $this.SalaryDetails.indexOf(item) > -1) return;
                $this.SalaryDetails.push(item);
}
static addRangeSalaryDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.FMYSalaryGroup.addSalaryDetails($this, item));
            }
static removeSalaryDetails = ($this, item) => {
                if ($this == null || $this.SalaryDetails == null || $this.SalaryDetails.indexOf(item) === -1) return;
                var _index = $this.SalaryDetails.indexOf(item);
                $this.SalaryDetails.splice(_index, 1);
}
static clearSalaryDetails = ($this) => { $this.SalaryDetails = null; }

static GetKey(salary: any): any{return salary?.Salary?.AADECode?.Code + "_" + salary?.Salary?.AADECode?.Code;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Key == null || $this.Key == "";
            }


}